import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { 
  UserOutlined, 
  BookOutlined, 
  FolderOutlined, 
  ShoppingCartOutlined 
} from '@ant-design/icons';

const OverviewStatsCards = ({ data }) => {
  // Helper function to safely get data from different possible structures
  const getData = (path) => {
    if (!data) return 0;
    
    // Try different possible data structures
    const paths = [
      path,
      `overview.${path}`,
      `data.${path}`,
      `data.overview.${path}`
    ];
    
    for (const dataPath of paths) {
      const value = dataPath.split('.').reduce((obj, key) => obj?.[key], data);
      if (value !== undefined && value !== null) {
        return value;
      }
    }
    
    return 0;
  };

  if (!data) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '16px', color: '#666', marginBottom: '10px' }}>
          Loading statistics...
        </div>
        <div style={{ fontSize: '14px', color: '#999' }}>
          Please wait while we fetch the latest data
        </div>
      </div>
    );
  }

  const stats = [
    {
      title: 'Total Learners',
      value: getData('totalLearners'),
      icon: <UserOutlined style={{ fontSize: '24px', color: '#1890ff' }} />,
      color: '#1890ff'
    },
    {
      title: 'Total Courses',
      value: getData('totalCourses'),
      icon: <BookOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
      color: '#52c41a'
    },
    {
      title: 'Total Categories',
      value: getData('totalCategories'),
      icon: <FolderOutlined style={{ fontSize: '24px', color: '#fa8c16' }} />,
      color: '#fa8c16'
    },
    {
      title: 'Total Orders',
      value: getData('totalOrders'),
      icon: <ShoppingCartOutlined style={{ fontSize: '24px', color: '#f5222d' }} />,
      color: '#f5222d'
    }
  ];

  return (
    <div className="overview-stats-container">
      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <Card className="overview-stat-card">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <Statistic
                    title={stat.title}
                    value={stat.value}
                    valueStyle={{ 
                      color: stat.color, 
                      fontSize: '28px', 
                      fontWeight: 'bold' 
                    }}
                  />
                </div>
                <div style={{ marginLeft: '16px' }}>
                  {stat.icon}
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default OverviewStatsCards; 